import { PayloadAction } from '@reduxjs/toolkit';
import { FavouriteState } from '../slice';
import { FavouriteProduct } from '../types';

const addFavouriteProductReducer = (state: FavouriteState, action: PayloadAction<string>) => {
  const isInFavourites = state.products.findIndex((product) => product.sku === action.payload) >= 0;
  if (isInFavourites) return;

  state.products.push({
    sku: action.payload,
  } as FavouriteProduct);
};

export default addFavouriteProductReducer;
